// BalanceApi.js

import apiServices from "../common/apiServices";

 // Define the tag types related to entication
export const addTagTypes = [ 'Balance'];

// Enhance the base API service by adding entication-related tag types
const BalanceApi = apiServices
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      // Create a new 
        createBalance: build.mutation({
            query: ({ Balance, user_id }) => ({
              url: `/balances/${user_id}`,
              method: 'POST',
              data: Balance,  // Using ShopProfile interface data here
            }),
            invalidatesTags: ['Balance'],  // Invalidate ShopProfiles tags after creation
          }),
      // Fetch Balance query (GET request to /me)
      getBalance: build.query({
        query: (userId) => ({
          url: `/balances/${userId}`,
        }),
        providesTags: ['Balance'],
      }),  
      updateBalance: build.mutation({
        query: ({ userId, newBalance }) => ({
          url: `/balances/${userId}?newBalance=${newBalance}`, // Pass `newBalance` as a query parameter
          method: 'PUT',
          body: {}, // Correct usage: use `body` for the payload (even if empty)
        }),
        invalidatesTags: ['Balance'], // Correctly reference the invalidation tags
      }),
       
    }),
    overrideExisting: false,
  });

export default BalanceApi;

// Exporting hooks for each endpoint to be used in components
export const {
    useCreateBalanceMutation,
   useGetBalanceQuery,
   useUpdateBalanceMutation
} = BalanceApi;


